export default {
  memberId: state => state.memberId,
  memberRole: state => state.memberRole
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/hangfire/getters.js